import { useState, useEffect } from 'react';
export const useWindowSize = () => {
    // Khởi tạo state để lưu kích thước màn hình
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    // useEffect để lắng nghe sự kiện thay đổi kích thước
    useEffect(() => {
        // Hàm để cập nhật kích thước
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        // Gắn sự kiện resize
        window.addEventListener('resize', handleResize);
        // Cleanup sự kiện khi component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);  // Chỉ chạy một lần khi component mount
    return windowSize;
};